export default "__VITE_ASSET__BpXwwX9o__"